import { DropdownData } from '@zayan-erp/shared';
import { AddressV2, AddressV2Create } from './address-v2.models';

export const CLOSING_SCHEME_LABELS: Record<number, string> = {
  1: 'Freehold',
  2: 'POTL/CEC',
  3: 'Condominium'
};

export const CLOSING_SCHEME_OPTIONS: DropdownData[] = [
  { id: '1', firstLabel: CLOSING_SCHEME_LABELS[1] },
  { id: '2', firstLabel: CLOSING_SCHEME_LABELS[2] },
  { id: '3', firstLabel: CLOSING_SCHEME_LABELS[3] }
];

export interface Project {
  id: string;
  projCode: string;
  projectName: string;
  buildID: string | null;
  oUnitCodeId: string | null;
  oUnitCodeName?: string | null;
  companyId: string;
  divisionId: string;
  divisionName?: string | null;
  companyCode: string;
  companyName?: string | null;
  constructionTypeId: string | null;
  closingScheme?: number | null;
  sellingPriceTypeId: string | null;
  hardCostJobTypeId: string | null;
  softCostJobTypeId: string | null;
  salesTaxClassId: string | null;
  cityId: string | null;
  projectTypeId: string | null;
  constructionTypeCode?: string | null;
  constructionTypeName?: string | null;
  sellingPriceTypeCode?: string | null;
  sellingPriceTypeName?: string | null;
  hardCostJobTypeCode?: string | null;
  hardCostJobTypeName?: string | null;
  softCostJobTypeCode?: string | null;
  softCostJobTypeName?: string | null;
  salesTaxClassCode?: string | null;
  salesTaxClassName?: string | null;
  cityCode?: string | null;
  cityName?: string | null;

  slCode: string | null;
  bnRegNo: string | null;
  warrRefNo: string | null;
  planNo: string | null;
  condo: boolean | null;
  is1440: boolean | null;
  grUnitNo: number | null;
  address?: AddressV2 | AddressV2Create | null;
  noOfLots: number | null;
  softCostLot: number | null;
  listCode: string | null;
  frozen: boolean;
  hidden: boolean;
  unitCode?: string;
  productListId?: string;
  currencyCode?: string | null;
  legalMapUrl?: string | null;
  projectType?: {
    id: string;
    code?: string | null;
    name?: string | null;
  } | null;
}

export type PublicProject = Pick<Project, 'id' | 'projCode' | 'projectName'> & {
  mapImageUrl: string;
};

export interface ConstructionType {
  id: string;
  name: string;
  code: string;
}

export interface ProjectModel {
  id: string;
  modelName: string;
}

export interface SalesTaxClass {
  id: string;
  code: string;
  description?: string;
}

export interface SellingPriceType {
  id: string;
  name: string;
  code: string;
}

export interface ProjectImportFileItem {
  Projcode: string;
  ProjectName: string | null;
  BuildID: string | null;
  // ProjID: string;
  OUnitCodeId: string | null;
  CompCode: string;
  DivCode: string;
  ConstructionTypeId: string | null;
  SellingPriceTypeId: string | null;
  HardCostJobTypeId: string | null;
  SoftCostJobTypeId: string | null;
  SalesTaxClassId: string | null;
  CityId: string | null;
  SlCode: string | null;
  BnRegNo: string | null;
  WarrRefNo: string | null;
  PlanNo: string | null;
  Condo: boolean | null;
  Is1440: boolean | null;
  GrUnitNo: number | null;
  AddrLine1: string | null;
  AddrLine2: string | null;
  SoftCostLot: number | null;
  ListCode: string | null;
  Frozen: boolean;
  Hidden: boolean;
}

export interface ProjectImportTableItemMetadata {
  value: string | number | boolean | null;
  isValid: boolean;
  message: string | null;
  isDuplicate: boolean;
}

export interface ProjectImportTableItem {
  Projcode: ProjectImportTableItemMetadata;
  ProjectName: ProjectImportTableItemMetadata;
  BuildID: ProjectImportTableItemMetadata;
  OUnitCodeId: ProjectImportTableItemMetadata;
  CompanyId: ProjectImportTableItemMetadata;
  DivCode: ProjectImportTableItemMetadata;
  ConstructionTypeId: ProjectImportTableItemMetadata;
  SellingPriceTypeId: ProjectImportTableItemMetadata;
  HardCostJobTypeId: ProjectImportTableItemMetadata;
  SoftCostJobTypeId: ProjectImportTableItemMetadata;
  SalesTaxClassId: ProjectImportTableItemMetadata;
  CityId: ProjectImportTableItemMetadata;
  ProjectTypeId: ProjectImportTableItemMetadata;
  SlCode: ProjectImportTableItemMetadata;
  BnRegNo: ProjectImportTableItemMetadata;
  WarrRefNo: ProjectImportTableItemMetadata;
  PlanNo: ProjectImportTableItemMetadata;
  Condo: ProjectImportTableItemMetadata;
  Is1440: ProjectImportTableItemMetadata;
  GrUnitNo: ProjectImportTableItemMetadata;
  AddrLine1: ProjectImportTableItemMetadata;
  AddrLine2: ProjectImportTableItemMetadata;
  NoOfLots: ProjectImportTableItemMetadata;
  SoftCostLot: ProjectImportTableItemMetadata;
  ListCode: ProjectImportTableItemMetadata;
  Frozen: ProjectImportTableItemMetadata;
  Hidden: ProjectImportTableItemMetadata;
  inEditMode: boolean;
  models: ProjectModel[];
}

export interface EnrichedProjectImportTableItem extends ProjectImportTableItem {
  oUnitCodeName?: string;
  divisionName?: string;
  companyName?: string;
  constructionTypeName?: string;
  sellingPriceTypeName?: string;
  hardCostJobTypeName?: string;
  softCostJobTypeName?: string;
  salesTaxClassName?: string;
  cityName?: string;
}

export interface SitingAnalysisCell {
  lotNo: string;
  modelName: string;
  unfit: number | null;
}

export interface SitingAnalysisModelElevation {
  elevationId: string;
  elevationCode: string;
}

export interface SitingAnalysisLotModel {
  modelId: string;
  modelName: string;
  elevations?: SitingAnalysisModelElevation[];
}

export interface SitingAnalysisLot {
  lotId: string;
  lotNo: string;
  models: SitingAnalysisLotModel[];
}

export interface SitingAnalysis {
  projectId: string;
  lots?: SitingAnalysisLot[];
  lotNumbers?: string[];
  modelNames?: string[];
  cells?: SitingAnalysisCell[];
}
